import React, { useEffect, useState , useContext , useRef , useMemo} from "react";
import '../styles/home-page.style.scss';
import { Row , Select , Col , DatePicker , Button , Form ,Typography}  from 'antd';
import { useDispatch , useSelector} from "react-redux";
import { getOriginCities , getDestinationCities,fetchSchedules , setSelectedScheduleSeats} from './../actions/home.action';
import { originsSelector,originSupportedDestinationsSelector , selectedScheduleSeatsSelector} from './../selector/home.selector';
import { getUrlVars, isValid, isValidArray} from './../utils/utilities';
import { isMultiOperatorAgentCheck } from './../utils/constant';
import { getAPIDateFormat } from './../utils/date.utils';
import { OpenBookedTicketModal } from './../components/ticket-summary-components/open-booked-ticket-modal.component';
import {
    SwapOutlined,
    CloseOutlined
  } from '@ant-design/icons';
import { ScrollableCalendar } from './../components/scrollable-calendar/scrollable-calendar.component';
import { DeviceContext } from './../components/device-provider/device-provider';
import { SessionTimeOut } from './../components/session-time-out-component/session-time-out.component';
import { SearchResultsComponent } from './../components/search-results/search-results.component';
import moment from 'moment';
import { useLocation, useHistory } from "react-router-dom";
import { OverDueText } from "../components/over-due-text-component/over-due-text.component";
import { DemandDaysPicker, dateFullCellRender, renderDemandDaysList, getDemandDaysForDate, renderMonthDemandDaysList } from './../components/demand-days-picker/demand-days-picker.component';

const {
    Text
} = Typography;

const { Option } = Select;

let initialDate = moment().utcOffset("+05:30");

const safeDecodeURIComponent=(value)=>{
    try{
        return decodeURIComponent(value);
    }catch(e){
        return value;
    }
}

const renderOrigins=(origins)=>
{
    // Multi operator agents search across every operator, so an all to all
    // search would pull the whole inventory - they must pick both cities.
    let originsArray=isMultiOperatorAgentCheck()?[]:[<Option value={'all'}>{'All'}</Option>];
    if(isValidArray(origins)&&origins.length>0){
        origins.forEach(element => {
            if(isValid(element)&&isValid(element.city_name)){
                originsArray.push(<Option value={element.city_name}>{element.city_name}</Option>)
            }
        });
    }
    return originsArray;
}

const renderDestinations=(origins,destinations,origin)=>
{
    let destiArray=[];
    if(!isMultiOperatorAgentCheck()){
        destiArray.push(<Option value={'all'}>{'All'}</Option>);
    }

        if(isValidArray(destinations)&&destinations.length>0){
            destinations.forEach(element => {
                if(isValid(element)&&isValid(element.city_name)){
                    destiArray.push(<Option value={element.city_name}>{element.city_name}</Option>)
                }
            });
        }else{
            destiArray = renderOrigins(origins);
        }

    return destiArray;
}

/*
  Builds a lookup of lowercased city name -> lowercased alias name
  from the city objects returned by /api/originCities & /api/destinationCities
*/
const buildCityAliasMap=(...cityLists)=>
{
    let map={};
    cityLists.forEach(list => {
        if(isValidArray(list)){
            list.forEach(item => {
                if(item&&isValid(item.city_name)){
                    map[item.city_name.toLowerCase()] = isValid(item.alias_city_name)?item.alias_city_name.toLowerCase():'';
                }
            });
        }
    });
    return map;
}

/*
  Matches the typed input against both the city name and its alias name,
  while the dropdown still displays only the city name
*/
const cityFilterOption=(aliasMap)=>(input,option)=>
{
    let query=(input||'').toLowerCase();
    let cityName=(option.value||'').toString().toLowerCase();
    let aliasName=aliasMap[cityName]||'';
    return cityName.indexOf(query)>=0||aliasName.indexOf(query)>=0;
}



export const HomePage = () => {

    const dispatch = useDispatch();
    const origins = useSelector(originsSelector);
    const destinations = useSelector(originSupportedDestinationsSelector);
    const cityAliasMap = useMemo(()=>buildCityAliasMap(origins,destinations),[origins,destinations]);
    const filterCityOption = useMemo(()=>cityFilterOption(cityAliasMap),[cityAliasMap]);
    const [schedules,setSchedules]=useState(undefined);
    const [origininput,setOrigin]=useState(undefined);
    const [destinationinput,setDestination]=useState(undefined);
    const [showResults,setShowResults]=useState(false);
    const [openTripRouteId,setOpenTripRouteId] = useState(undefined);
    const [inputDate,setInputDate] = useState(null);
    const [originDropdownOpen, setOriginDropdownOpen] = useState(false);
    const [destinationDropdownOpen, setDestinationDropdownOpen] = useState(false);
    const [datePickerOpen, setDatePickerOpen] = useState(false);
    const [demandDaysData, setDemandDaysData] = useState({});
    const [currentPickerMonth, setCurrentPickerMonth] = useState(moment());
    const [searchHeaderHeight, setSearchHeaderHeight] = useState(0);
    const [floaterExpanded, setFloaterExpanded] = useState(false);
    const [isShrunk, setIsShrunk] = useState(false);
    const [formFocused, setFormFocused] = useState(false);
    const [searchHeaderRight, setSearchHeaderRight] = useState(0);
    const searchHeaderRef = useRef(null);



    const [form] = Form.useForm();
    const searchRef = useRef(null);
    const originRef = useRef(null);
    const destinationRef = useRef(null);
    const dateRef = useRef(null);
    const searchTokenRef = useRef(0);
    const skipUrlSearchRef = useRef(false);

    let location = useLocation();
    let history = useHistory();
    let {
        origin,
        destination,
        date
    } = getUrlVars(location.search);
    origin = isValid(origin)?safeDecodeURIComponent(origin):origin;
    destination = isValid(destination)?safeDecodeURIComponent(destination):destination;

    const onEnterPress=(e,inputType=null,refs)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            setTimeout(() => {
                if(inputType === 'origin' && refs.destinationRef){
                    refs.destinationRef.current?.focus();
                    setDestinationDropdownOpen(true);
                }else if(inputType === 'destination' && refs.dateRef){
                    refs.dateRef.current?.focus();
                    setDatePickerOpen(true);
                }
            }, 100);
        }
    }
    useEffect(()=>{
        // Clearing old url params after a form search must not re-run the search
        if(skipUrlSearchRef.current){
            skipUrlSearchRef.current=false;
            return;
        }
        // Multi operator agents have no all to all option, so a bookmarked or
        // stale all to all url must not run that search - drop the cities from
        // the url and let the cleaned url re-run this effect with an empty form.
        if(isMultiOperatorAgentCheck()&&(origin === 'all'||destination === 'all')){
            let keepDate = isValid(date)&&moment(date,'YYYY-MM-DD',true).isValid();
            history.replace({search:keepDate?`?date=${date}`:''});
            return;
        }
        if(isValid(origin)){
            form.setFieldsValue({origin:origin});
            if(origin!==origininput){
                dispatch(getDestinationCities(origin));
            }
            setOrigin(origin);
        }
        if(isValid(destination)){
            form.setFieldsValue({destination:destination});
            setDestination(destination);
        }
        let isDateValid = isValid(date)&&moment(date,'YYYY-MM-DD',true).isValid();
        if(isDateValid){
            form.setFieldsValue({date:moment(date)})
        }
        if(isValid(origin)&&isValid(destination)){
            performSearch(origin,destination,isDateValid?date:getAPIDateFormat(form.getFieldValue('date')));
        }else{
            searchTokenRef.current++;
            resetSchedules();
            setShowResults(false);
        }
    },[location.search]);

    let seats = useSelector(selectedScheduleSeatsSelector);

    const setSeats=(data)=>{
        dispatch(setSelectedScheduleSeats(data));
    }

    const {
        isMobile
    }=useContext(DeviceContext);

    useEffect(()=>{
        function call() {
            resetSchedules();
            dispatch(getOriginCities());
          }
          call();
    },[]);

    // Keep the in-flow placeholder matched to the fixed header's collapsed
    // height; the expanded form overlays the results instead of pushing them
    // On desktop the full form stays visible until scrolled, so keep the
    // placeholder at the unshrunk height; otherwise the results jump upwards
    // when the header turns into the floater mid-scroll. Collapse/expand is
    // animated, so re-measure once the transition settles as well
    const measureSearchHeader=()=>{
        if(showResults&&searchHeaderRef.current&&!floaterExpanded&&(isMobile||!isShrunk)){
            setSearchHeaderHeight(searchHeaderRef.current.offsetHeight);
        }
    }

    useEffect(()=>{
        measureSearchHeader();
    },[showResults,isMobile,inputDate,schedules,floaterExpanded,isShrunk]);

    // The page scrolls inside an in-page container (not the window), whose
    // scrollbar sits inside the viewport and would be painted under the fixed
    // header. Find that container from the header itself and stop the header
    // short of its scrollbar. macOS overlay scrollbars take no width (nothing
    // to stop short of), so on desktop such a container gets a regular,
    // native-sized scrollbar while the header is pinned
    useEffect(()=>{
        if(!showResults){
            return;
        }
        let scroller = null;
        let observer = null;
        const isScrollable=(node)=>{
            const overflowY = window.getComputedStyle(node).overflowY;
            return (overflowY==='auto'||overflowY==='scroll'||overflowY==='overlay')&&node.scrollHeight>node.clientHeight;
        };
        const findScroller=()=>{
            let node = searchHeaderRef.current?searchHeaderRef.current.parentElement:null;
            while(node&&node!==document.documentElement){
                if(isScrollable(node)){
                    return node;
                }
                node = node.parentElement;
            }
            // Window scrolling: a fixed header never covers the viewport scrollbar
            return null;
        };
        const setScroller=(next)=>{
            if(next===scroller){
                return;
            }
            if(scroller){
                scroller.classList.remove('search-header-scrollbar');
                if(observer){
                    observer.unobserve(scroller);
                }
            }
            scroller = next;
            if(scroller){
                const gutter = scroller.offsetWidth-scroller.clientWidth-scroller.clientLeft*2;
                if(!isMobile&&gutter<=0){
                    scroller.classList.add('search-header-scrollbar');
                }
                if(observer){
                    observer.observe(scroller);
                }
            }
        };
        const updateRight=()=>{
            setScroller(findScroller());
            if(!scroller){
                setSearchHeaderRight(0);
                return;
            }
            const rect = scroller.getBoundingClientRect();
            const scrollAreaRight = rect.left+scroller.clientLeft+scroller.clientWidth;
            setSearchHeaderRight(Math.max(0, Math.round(window.innerWidth-scrollAreaRight)));
        };
        // A scroll event's target is the real scroller; adopt it if it holds the header
        const onScroll=(e)=>{
            const target = e.target;
            if(target&&target!==scroller&&target.nodeType===1&&searchHeaderRef.current&&target.contains(searchHeaderRef.current)){
                updateRight();
            }
        };
        if(typeof ResizeObserver!=='undefined'){
            observer = new ResizeObserver(updateRight);
            observer.observe(document.body);
        }
        updateRight();
        window.addEventListener('resize', updateRight);
        window.addEventListener('scroll', onScroll, {passive:true, capture:true});
        return ()=>{
            setScroller(null);
            window.removeEventListener('resize', updateRight);
            window.removeEventListener('scroll', onScroll, {capture:true});
            if(observer){
                observer.disconnect();
            }
        };
    },[showResults,schedules,isMobile]);

    // Compact the pinned header once scrolled down, restore at the top. The page
    // scrolls inside #root-index-html-file (overflow-x:auto forces computed
    // overflow-y:auto), so listen in capture phase and take the largest offset
    useEffect(()=>{
        const onScroll=(e)=>{
            const rootContainer = document.getElementById('root-index-html-file');
            const top = Math.max(
                window.pageYOffset||0,
                document.documentElement.scrollTop||0,
                document.body.scrollTop||0,
                isValid(rootContainer)?rootContainer.scrollTop:0,
                (e&&e.target&&typeof e.target.scrollTop==='number')?e.target.scrollTop:0
            );
            setIsShrunk(top>40);
        };
        window.addEventListener('scroll', onScroll, {passive:true, capture:true});
        return ()=>window.removeEventListener('scroll', onScroll, {capture:true});
    },[]);

    const onOriginChange=(value)=>{
        setOrigin(value);
        if((destinationinput !== 'all' && value === 'all')||(value !== 'all' && destinationinput === 'all')){
            form.setFieldsValue({destination:null})
        }
        dispatch(getDestinationCities(value));
    }

    const onDestionationChange=(value)=>{
        setDestination(value);
    }

    const performSearch=(origin,destination,selectedDate)=>{
        setInputDate(selectedDate);
        resetSchedules();
        let searchToken = ++searchTokenRef.current;
        dispatch(fetchSchedules(origin,destination,selectedDate,false,false , (fetchedSchedules)=>{
            if(searchToken!==searchTokenRef.current){
                return;
            }
            setSchedules(fetchedSchedules);
            setShowResults(true);
        }));
    }

    const onFinish=(values)=>{
        let origin=values.origin;
        let destination=values.destination;
        // The date strip calls this directly, bypassing the form's required rules.
        // Multi operator agents start with an empty form, so guard against both
        // cities turning into an "undefined" search.
        if(!isValid(origin)||!isValid(destination)){
            return;
        }
        let selectedDate=getAPIDateFormat(values.date);
        performSearch(origin,destination,selectedDate);
        // Searches are not kept in the url, so drop any params the page was opened with
        if(location.search){
            skipUrlSearchRef.current=true;
            history.replace({search:''});
        }
        setFloaterExpanded(false);
        setIsShrunk(false);
        // Leave the form so the header can collapse again after searching
        if(document.activeElement&&typeof document.activeElement.blur==='function'){
            document.activeElement.blur();
        }
        setFormFocused(false);
    }

    const resetSchedules=()=>{
        setSchedules(undefined);
        setSeats(null);
        setOpenTripRouteId(undefined);
    }

    const refetchDetails=()=>{
        let values = form.getFieldsValue();
        onFinish(values,false);
    }

    const onChangeDateStrip=(stripDate)=>{
        form.setFieldsValue({
            date:moment.parseZone(stripDate)
        });
        let values = form.getFieldsValue();
        onFinish(values);
    }

    const isHeaderFixed = showResults;
    // Mobile always collapses into the floater; desktop keeps the full
    // origin/destination/date row and collapses only while scrolled down
    // Never collapse while the user is still picking origin/destination/date
    const isEditingSearch = formFocused||originDropdownOpen||destinationDropdownOpen||datePickerOpen;
    const canCollapse = isHeaderFixed&&(isMobile||isShrunk);
    const showFloater = canCollapse&&!floaterExpanded&&!isEditingSearch;
    const floaterOrigin = form.getFieldValue('origin')||origininput||'Origin';
    const floaterDestination = form.getFieldValue('destination')||destinationinput||'Destination';

    return (
        <div className="home-page-root">
            <div  className="home-page-form">
                    <OverDueText />
                    {isHeaderFixed&&<div style={{height:searchHeaderHeight}} />}
                    <div
                        ref={searchHeaderRef}
                        className={`home-search-header${isHeaderFixed?' home-search-header-fixed':''}${showFloater?' home-search-header-collapsed':''}${isHeaderFixed&&isShrunk?' home-search-header-shrunk':''}`}
                        style={isHeaderFixed?{right:searchHeaderRight}:undefined}
                        onTransitionEnd={measureSearchHeader}
                    >
                    {isHeaderFixed&&
                        <div className="search-collapsible search-floater-wrap">
                            <div className="search-collapsible-inner">
                                <div className="search-floater" onClick={()=>setFloaterExpanded(true)}>
                                    <span className="search-floater-city">{floaterOrigin}</span>
                                    <SwapOutlined />
                                    <span className="search-floater-city">{floaterDestination}</span>
                                </div>
                            </div>
                        </div>
                    }
                    {canCollapse&&floaterExpanded&&
                        <div className="search-floater-close" onClick={()=>setFloaterExpanded(false)}>
                            <CloseOutlined />
                        </div>
                    }
                    <div
                        className="search-collapsible home-search-form-block"
                        onFocus={()=>setFormFocused(true)}
                        onBlur={(e)=>{
                            if(!e.currentTarget.contains(e.relatedTarget)){
                                setFormFocused(false);
                            }
                        }}
                    >
                    <div className="search-collapsible-inner">
                    <Row justify="center" align="middle">
                            <Form
                            form={form}
                            onFinish={onFinish}
                            initialValues={isMultiOperatorAgentCheck()?{date:initialDate}:{origin:'all',destination:'all',date:initialDate}}
                            >
                            <Row gutter={[16,0]} justify="center" align="middle">
                                <Col xs={isMobile?24:null} sm={isMobile?24:null}>
                                    <Form.Item
                                                name="origin"
                                                rules={[{ required: true, message: 'Please input your origin!' }]}
                                                style={isMobile?{ marginBottom: "0px" }:{}}
                                        >
                                            <Select
                                                    ref={originRef}
                                                    size="large"
                                                    showSearch
                                                    placeholder="Select a origin"
                                                    onChange={onOriginChange}
                                                    filterOption={filterCityOption}
                                                    bordered={true}
                                                    className="defalut-select-style"
                                                    onInputKeyDown={(e)=>onEnterPress(e,'origin',{originRef,destinationRef,dateRef,searchRef})}
                                                    open={originDropdownOpen}
                                                    onDropdownVisibleChange={(open) => setOriginDropdownOpen(open)}
                                                >
                                                {renderOrigins(origins)}
                                                </Select>
                                        </Form.Item>
                                </Col>
                                <Col xs={isMobile?24:null} sm={isMobile?24:null}>
                                <Row justify="center">
                                    <Form.Item
                                    style={isMobile?{ margin: "0px" }:{}}
                                    >
                                        <Button
                                        className="transparentButton"
                                        type="text"
                                        icon={<SwapOutlined className={isMobile?"transform90Degrees":""}
                                        onClick={()=>{
                                           let {
                                               origin,
                                               destination
                                           } =form.getFieldsValue();
                                           form.setFieldsValue({
                                               origin:destination,
                                               destination:origin
                                           })
                                        }}
                                        />}
                                        >
                                        </Button>
                                    </Form.Item>
                                </Row> 
                                </Col>
                                <Col xs={isMobile?24:null} sm={isMobile?24:null}>
                                        <Form.Item
                                                name="destination"
                                                rules={[{ required: true, message: 'Please input your destination!' }]}
                                        >
                                                <Select
                                                    ref={destinationRef}
                                                    size="large"
                                                    showSearch
                                                    placeholder="Select a destination"
                                                    filterOption={filterCityOption}
                                                    onChange={onDestionationChange}
                                                    bordered={true}
                                                    className="defalut-select-style destination-select-drop-down"
                                                    onInputKeyDown={(e)=>onEnterPress(e,'destination',{originRef,destinationRef,dateRef,searchRef})}
                                                    open={destinationDropdownOpen}
                                                    onDropdownVisibleChange={(open) => setDestinationDropdownOpen(open)}
                                                >
                                                {renderDestinations(origins,destinations,origininput)}
                                                </Select>
                                        </Form.Item>
                                </Col>
                                <Col xs={isMobile?24:null} sm={isMobile?24:null}>
                                    <Row gutter={[16,16]}>
                                        <Col>
                                            <Form.Item
                                                        name="date"
                                                        rules={[{ required: true, message: 'Please input your date!' }]}
                                            >
                                                        <DatePicker 
                                                            ref={dateRef}
                                                            className="defalut-picker-style"
                                                            open={datePickerOpen}
                                                            onOpenChange={(open) => {
                                                                setDatePickerOpen(open);
                                                            }}
                                                            onPanelChange={(value) => {
                                                                setCurrentPickerMonth(value);
                                                            }}
                                                            dateRender={(current) => dateFullCellRender(current, demandDaysData)}
                                                            panelRender={(panelNode) => (
                                                                <div style={{ display: 'flex' }}>
                                                                    {panelNode}
                                                                    {renderMonthDemandDaysList(demandDaysData, currentPickerMonth)}
                                                                </div>
                                                            )}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    e.preventDefault();
                                                                    setDatePickerOpen(false);
                                                                    setTimeout(() => {
                                                                        refetchDetails();
                                                                    },100);
                                                                }
                                                            }}
                                                        />
                                            </Form.Item>
                                            <DemandDaysPicker 
                                                currentMonth={currentPickerMonth}
                                                onDataLoaded={(data) => setDemandDaysData(data)}
                                                origin={origininput}
                                                destination={destinationinput}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Item>
                                                    <Button type="primary" htmlType="submit" ref={searchRef}>Search</Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    </Row>
                    </div>
                    </div>
                    {showResults&&
                        <div className="scrollable-block-root">
                            <ScrollableCalendar
                                changeScrollableDate={onChangeDateStrip}
                                selectedDate={inputDate}
                            />
                        </div>
                    }
                    </div>
                    <div>
                        <SearchResultsComponent
                            schedules={schedules}
                            showResults={showResults}
                            setShowResults={setShowResults}
                            seats={seats}
                            openTripRouteId={openTripRouteId}
                            setOpenTripRouteId={setOpenTripRouteId}
                            onFareUpdateSuccess={refetchDetails}
                            onDriverUpdateSuccess={(scheduleId,vechicleId,phoneNo)=>{
                                    let formatedSchedules = schedules;
                                    for (let index = 0; index < formatedSchedules.length; index++) {
                                        const element = formatedSchedules[index];
                                        if(element.schedule_id === scheduleId){
                                            formatedSchedules[index].vechicle_id = vechicleId;
                                            formatedSchedules[index].phone_no = phoneNo;
                                        }
                                    }
                                    setSchedules([...formatedSchedules]);
                                    refetchDetails();
                            }}

                            selectedDate={inputDate}
                            refetchDetails={refetchDetails}
                            setSchedules={setSchedules}
                        />
                    </div>
            </div>
            <OpenBookedTicketModal />
            <SessionTimeOut />
        </div>
    );
}